// src/services/twilio/TwilioService.js
import { api } from '../../constants/api.js';
import { axios } from '../http/axios.js';

const TwilioService = {

    // Get room by booking ID
    getRoomByBooking: async (bookingId) => {
        try {
            const response = await axios.get(api.twilio.getRoomByBooking(bookingId));
            return response.data;
        } catch (error) {
            console.error('Error fetching room by booking:', error);
            throw error;
        }
    },

    // Update createRoomRecord to better handle existing rooms
    createRoomRecord: async (roomName, bookingId) => {
        try {
            const response = await axios.post(api.twilio.createRoomRecord, {
                roomName,
                associatedBooking: bookingId,
                createTwilioRoom: true // Add flag to create actual Twilio room
            });
            return response.data;
        } catch (error) {
            console.error('Error creating Room record:', error);
            throw error;
        }
    },

    // Get token for video room
    getVideoToken: async (roomName, identity) => {
        try {
            const response = await axios.post(api.twilio.getVideoToken, { roomName, identity });
            return response.data; // { token, roomName, identity, expiresIn }
        } catch (error) {
            console.error('Error fetching Twilio token:', error);
            throw error;
        }
    },

    // Create or join a room
    createOrJoinRoom: async (roomName) => {
        try {
            const response = await axios.post(api.twilio.createRoom, { roomName });
            return response.data; // { room }
        } catch (error) {
            console.error('Error creating/joining room:', error);
            throw error;
        }
    },

    // Leave a room
    leaveRoom: async (roomName) => {
        try {
            const response = await axios.post(api.twilio.leaveRoom, { roomName });
            return response.data;
        } catch (error) {
            console.error('Error leaving room:', error);
            throw error;
        }
    },

    // Get room participants
    getRoomParticipants: async (roomName) => {
        try {
            const response = await axios.get(`${api.twilio.roomParticipants}/${roomName}`);
            return response.data; // { participants }
        } catch (error) {
            console.error('Error fetching room participants:', error);
            throw error;
        }
    },

    // Check if room exists
    checkRoom: async (roomName) => {
        try {
            const response = await axios.get(`${api.twilio.checkRoom}/${roomName}`);
            return response.data; // { exists, status }
        } catch (error) {
            console.error('Error checking room:', error);
            throw error;
        }
    },

    // New method: Request to join a room
    requestJoin: async (roomName, username) => {
        try {
            const response = await axios.post(api.twilio.requestJoin, {
                roomName,
                username
            });
            return response.data; // { status: 'pending' | 'accepted' | 'rejected' }
        } catch (error) {
            console.error('Error requesting to join:', error);
            throw error;
        }
    },

    getRoomDetails: async (roomName, localToken) => {
        try {
            const response = await axios.get(api.twilio.getRoomDetails(roomName), {
                headers: { Authorization: `Bearer ${localToken}` }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching room details:', error);
            throw error;
        }
    },
};

export default TwilioService;
